module.exports = __webpack_public_path__ + "static/img/成功@3x.d2e4438.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/登录注册/成功@3x.png
// module id = Xh2v
// module chunks = 192